import { fetch } from 'app/utils/data'
import { default as deserialize } from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    currentPurgedPendingKits: (state) => state.list
  },

  mutations: {
    setPurgedPendingKits(state, newKits) {
      state.list = newKits
    }
  },

  actions: {
    async fetchPurgedPendingKits({ commit }, { month, year }) {
      const response = await fetch({ url: '/api/admin/purged-pending-kits/' + month + '/' + year })
      const kits = await deserialize(response.data)

      commit('setPurgedPendingKits', kits)
    }
  }
}
